<div class="episodes-section">
  <div class="episodes-section-title-bar">
    <div class="change-season-section">
      @if (ProgramData().seasons.length > 1) {
        @if (Episode()) {
          <h3>سایر قسمت‌های</h3>
        } @else {
          <h3>قسمت‌های</h3>
        }
        <app-menu-button [matMenuTriggerFor]="menu" [Text]="selectedSeasonTitle()" Appearance="accent" />
        <mat-menu #menu="matMenu" class="select-season-menu" xPosition="before">
          @for (item of ProgramData().seasons; track item) {
            <button mat-menu-item (click)="handleChangeSeason(item)">
              {{ item?.title }}
            </button>
          }
        </mat-menu>
      } @else {
        @if (Episode()) {
          <h3>سایر قسمت‌های {{ ProgramData().program.title }}</h3>
        } @else {
          <h3>قسمت‌های {{ ProgramData().program.title }}</h3>
        }
      }
    </div>
  </div>
  <div class="episodes-item-box">
    @if (loading()) {
      <app-loading-spinner [Size]="64" />
    } @else {
      @for (item of SeasonEpisodes(); track item) {
        <div
          [class]="[
            'episode-item',
            item.releaseStatus !== episodeReleaseStatus.Released ? 'unreleased' : '',
            ProgramHasCopyright() ? 'has-copyright' : '',
          ]"
        >
          <button class="episode-image" (click)="handlePlayEpisode(item)" mat-ripple>
            <app-image-generator
              [sizes]="episodeSizes"
              [src]="item.landscapeImagePath"
              [name]="item.title"
              imageType="landscape"
            />
            @if (ProgramHasCopyright()) {
              <app-icon-button
                class="episode-play-button"
                Icon="public_off"
                Appearance="secondary"
                [IsFillIcon]="true"
                [IsButton]="true"
              />
            } @else {
              <app-icon-button
                class="episode-play-button"
                Icon="play_arrow"
                Appearance="secondary"
                [IsFillIcon]="true"
                [IsButton]="true"
              />
            }
            @if (item.releaseStatus === episodeReleaseStatus.Upcoming) {
              @if (item.releaseDate) {
                <div class="upcoming-box">
                  <app-countdown-release [ReleaseDate]="item.releaseDate" />
                </div>
              }
            } @else if (item.releaseStatus === episodeReleaseStatus.ComingSoon) {
              <div class="coming-soon-box">
                <span>به زودی</span>
              </div>
            }
            <div class="badge-container">
              @if (item.accessType === accessType.Free) {
                <app-sheyda-badge Text="رایگان" />
              }
              @if (ProgramData().program.isExclusive) {
                <app-sheyda-badge [IsExclusive]="true" />
              }
            </div>
          </button>
          <div class="episode-metadata">
            <h3>
              <div class="episode-metadata-title">
                {{ item.title }}
                <app-icon-button Icon="info" Link="/e/{{ item.uid }}" Appearance="default" />
              </div>
              @if (item.releaseStatus === episodeReleaseStatus.Released) {
                <span class="episode-metadata-duration">{{ item.duration | duration }}</span>
              }
            </h3>
            <p>{{ item.summary }}</p>
          </div>
        </div>
      }
    }
  </div>
</div>
